import api from '@/api';

export default {
  handleInstagramAuthCallback(code) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/instagrams/handleAuth', false, { code })
        .then(response => {
          if (response.status !== 200) {
            reject(response);
            return;
          }

          resolve(response.data);
        })
        .catch(error => {
          // Request failed.
          reject(error);
        });
    });
  },
  handleInstagramIntegrateCallback(code, userID, facebookId) {
    return new Promise(function (resolve, reject) {
      api
        .request(
          'post',
          '/api/v1/instagrams/graph/api/basic-instagram-auth/callback-handler?facebookId=' + facebookId + '&userId=' + userID,
          true,
          { code }
        )
        .then(response => {
          if (response.status !== 200) {
            reject(response);
            return;
          }

          resolve(response.data);
        })
        .catch(error => {
          // Request failed.
          reject(error);
        });
    });
  },
  async getLivePostMetrics(url) {
    let response = await api.request('post', `api/v1/instagrams/media/post`, true, url);
    if (response.status !== 200) {
      throw new Error('External Error');
    }
    return response.data;
  },
  async getInstagramProfileMetrics(igHandles) {
    let response = await api.request('post', `/api/v1/instagrams/helper/influencer/profile?handles=${igHandles}`, true);
    if (response.status !== 200) {
      throw new Error('External Error');
    }
    return response.data;
  },
  async fetchRecentPosts(igHandle, after, before) {
    let url = `/api/v1/instagrams/graph/api/${igHandle}/media`
    if (after) {
      url += '?after=' + after
    }
    if (before) {
      url += '?before=' + before
    }
    let response = await api.request('get', url, true);
    if (response.status !== 200) {
      throw new Error('External Error');
    }
    return response.data;
  },
  async searchByHashtag({ hashtag, type = 'recent_media' }) {
    let response = await api.request('get', `/api/v1/instagrams/graph/api/hashtag?q=${hashtag}&type=${type}`, true);
    if (response.status !== 200) {
      throw new Error('External Error');
    }
    return response.data;
  }
};



// WEBPACK FOOTER //
// ./src/components/views/Instagram/instagramAPIs.js